import {IPropertyDetailPromotion} from "../../property/actions/fetch_property_detail_promotions";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {useBooster} from "../hooks/use_booster";
import {useBoosterAnalytics} from "../hooks/use_booster_analytics";
import {IFlatBoosterParams} from "../types/booster_generic/IFlatBooster";
import {IHouseBoosterParams} from "../types/booster_generic/IHouseBooster";
import {IBoosterClickHandlerParams} from "../types/IBoosterClickHandlerParams";
import {BoosterPopover} from "./parts/BoosterPopover";
import {BoosterText} from "./parts/BoosterText";

export interface IPropertyBoosterProps {
    property: IPropertyDetail;
    promotions: IPropertyDetailPromotion[] | null;
    onBoosterClick?: (params: IBoosterClickHandlerParams) => void;
    className?: string;
}

export const PropertyBooster = (props: IPropertyBoosterProps) => {
    const {promotions, property, className} = props;

    const {segments, metadata} = useBooster<IHouseBoosterParams | IFlatBoosterParams>({
        offerId: property.offer.id,
        propertyId: property.id,
        property,
        promotions
    });
    const {trackBoosterClick} = useBoosterAnalytics<IHouseBoosterParams | IFlatBoosterParams>({segments, metadata});

    const handleBoosterClick = (closeBooster: () => void) => {
        if (props.onBoosterClick && metadata?.category && metadata?.type) {
            trackBoosterClick();

            props.onBoosterClick({
                category: metadata.category,
                type: metadata.type
            });
            closeBooster();
        }
    };

    return segments ? <BoosterPopover handleBoosterClick={handleBoosterClick} bodyText={<BoosterText text={segments} />} className={className} /> : null;
};
import {IPropertyDetailPromotion} from "../../property/actions/fetch_property_detail_promotions";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {useBooster} from "../hooks/use_booster";
import {useBoosterAnalytics} from "../hooks/use_booster_analytics";
import {IFlatBoosterParams} from "../types/booster_generic/IFlatBooster";
import {IHouseBoosterParams} from "../types/booster_generic/IHouseBooster";
import {IBoosterClickHandlerParams} from "../types/IBoosterClickHandlerParams";
import {BoosterPopover} from "./parts/BoosterPopover";
import {BoosterText} from "./parts/BoosterText";

export interface IPropertyBoosterProps {
    property: IPropertyDetail;
    promotions: IPropertyDetailPromotion[] | null;
    onBoosterClick?: (params: IBoosterClickHandlerParams) => void;
    className?: string;
}

export const PropertyBooster = (props: IPropertyBoosterProps) => {
    const {promotions, property, className} = props;

    const {segments, metadata} = useBooster<IHouseBoosterParams | IFlatBoosterParams>({
        offerId: property.offer.id,
        propertyId: property.id,
        property,
        promotions
    });
    const {trackBoosterClick} = useBoosterAnalytics<IHouseBoosterParams | IFlatBoosterParams>({segments, metadata});

    const handleBoosterClick = (closeBooster: () => void) => {
        if (props.onBoosterClick && metadata?.category && metadata?.type) {
            trackBoosterClick();

            props.onBoosterClick({
                category: metadata.category,
                type: metadata.type
            });
            closeBooster();
        }
    };

    return segments ? <BoosterPopover handleBoosterClick={handleBoosterClick} bodyText={<BoosterText text={segments} />} className={className} /> : null;
};
